// extracted by mini-css-extract-plugin
export default {"timeline_with_icons":"SectionTimeline_timeline_with_icons__QduSI","timeline_item":"SectionTimeline_timeline_item__rc8Wk","timeline_icon":"SectionTimeline_timeline_icon__87dGP"};